import { reduce, isEqual } from 'lodash';
import { cleanFalsyEntries } from './objectUtils';
import { parse } from 'qs';
import { isKeyOfObject } from 'src/common/utils/isKeyOfObject';

export const getObjectFromUrlSearchParams = (searchParams: URLSearchParams) => {
  return parse(searchParams.toString());
};

export const getUpdatedUrlSearchParams = (
  key: string,
  value: string,
  currentSearchParams: URLSearchParams,
) => {
  const objectCurrentSearchParams = getObjectFromUrlSearchParams(currentSearchParams);
  const updatedSearchParams = { ...objectCurrentSearchParams, [key]: value };
  return cleanFalsyEntries(updatedSearchParams);
};

export const getUpdatedUrlSearchParamsWithObject = (
  object: Record<string, string>,
  currentSearchParams: URLSearchParams,
) => {
  const objectCurrentSearchParams = getObjectFromUrlSearchParams(currentSearchParams);
  const updatedSearchParams = { ...objectCurrentSearchParams, ...object };
  return cleanFalsyEntries(updatedSearchParams);
};

export const cleanDefaultValuesURLSearchParams = <T extends string>(
  searchParams: Record<T, string | (string | null)[] | null | number | (number | null)[]>,
  defaultValues: Record<T, string | (string | null)[] | null | number | (number | null)[]>,
) =>
  reduce(
    searchParams,
    (cleandFilters, value, key) => {
      if (!isKeyOfObject(key, searchParams)) {
        return cleandFilters;
      }

      if (isEqual(value, defaultValues[key])) {
        return cleandFilters;
      }
      return {
        ...cleandFilters,
        [key]: Array.isArray(value) ? value.map(String) : value,
      };
    },
    {} as Record<T, string>,
  );

export type PaginationSerachParams = Record<'page' | 'rowsPerPage', string>;
export const cleanPaginationURLParams = <T extends string>(
  pagination: Record<T, string>,
  defaultValues?: PaginationSerachParams,
) =>
  cleanDefaultValuesURLSearchParams(
    pagination,
    (defaultValues ?? { page: '0', rowsPerPage: '25' }) as Record<T, string>,
  );
